import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ClientPaginationService, PaginationConfig } from '../../services/client-pagination.service';

@Component({
  selector: 'app-client-pagination',
  template: `
    <div class="mt-md pagination-container" *ngIf="totalItems > 0">
      <div>
        <span class="mr-sm">Rows per page:</span>
        <nz-select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)" class="w80">
          <nz-option [nzValue]="10" nzLabel="10"></nz-option>
          <nz-option [nzValue]="20" nzLabel="20"></nz-option>
          <nz-option [nzValue]="50" nzLabel="50"></nz-option>
          <nz-option [nzValue]="100" nzLabel="100"></nz-option>
        </nz-select>
      </div>
      <div>
        <nz-pagination [(nzPageIndex)]="currentPage" [nzTotal]="totalItems" [nzPageSize]="pageSize" (nzPageIndexChange)="onPageChange($event)"></nz-pagination>
      </div>
      <div *ngIf="totalItems > 0">
        <span class="mr-sm">Go to:</span>
        <input nz-input [(ngModel)]="gotoPageNumber" 
               placeholder="Page" 
               type="number" 
               [min]="1" 
               [max]="maxPages" 
               class="mr-sm w80 inline-block" 
               (keyup.enter)="goToPage()" />
        <button nz-button nzType="primary" (click)="goToPage()" [disabled]="!gotoPageNumber">Go</button>
      </div>
    </div>
  `
})
export class ClientPaginationComponent implements OnInit {
  @Input() totalItems: number = 0;
  @Input() pageSize: number = 10;
  @Input() currentPage: number = 1;
  @Input() maxPages: number = 1;
  
  @Output() pageSizeChange = new EventEmitter<number>();
  @Output() pageChange = new EventEmitter<number>();
  
  gotoPageNumber: any;

  constructor(
    private msg: NzMessageService,
    private clientPaginationService: ClientPaginationService
  ) {}

  ngOnInit() {}

  onPageSizeChange(size: number) {
    this.pageSizeChange.emit(size);
  }

  onPageChange(page: number) {
    this.pageChange.emit(page);
  }

  goToPage() {
    if (this.gotoPageNumber && this.gotoPageNumber >= 1 && this.gotoPageNumber <= this.maxPages) {
      this.pageChange.emit(this.gotoPageNumber);
      this.gotoPageNumber = null;
    } else if (this.gotoPageNumber > this.maxPages) {
      this.msg.warning(`Page ${this.gotoPageNumber} does not exist. Maximum page is ${this.maxPages}`);
      this.gotoPageNumber = null;
    }
  }
}